var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Tipos de Tarefa","titleIcon":"fas fa-tags"}},[_c('crud-simples',{attrs:{"endpoint":"api/tarefa-tipo","rotuloNovo":"NOVO TIPO","nomeSingular":"tipo de tarefa","placeholderBusca":"Pesquisar por nome","perfisEscrita":[4, 5],"campos":_vm.campos,"colunas":_vm.colunas}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }